/* eslint-disable */
import { useState, useEffect, useContext } from "react"
import ThemeContext from "../context/ThemeContext"

export const useWindowSize = () => {
  const { hydrated: isClient } = useContext(ThemeContext)
  const [windowSize, setWindowSize] = useState(getSize)

  function handleResize() {
    setWindowSize(getSize())
  }

  useEffect(() => {
    if (!isClient) {
      return
    }
    // handles setting initial window size on an ssr environment,
    // then adds a resize handler
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [isClient]) // Empty array ensures that effect is only run on mount and unmount

  function getSize() {
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined,
    }
  }

  return windowSize
}
